import React, { useState, useCallback } from "react";
import { Popover, SxProps, Theme } from "@mui/material";
import { ButtonActionCalendar } from "modules/DeclareLeave/components/CustomCalendarTimeKeeping/components/Modals/RequestLeave/styles";
import pxToRem from "theme/base/pxToRem";
// import { ButtonActionCalendar } from "modules/DeclareLeave/components/CustomCalendarTimeKeeping/components/Modals/RequestLeave/styles";

interface CustomPopoverProps {
  buttonLabel: React.ReactNode;
  children: (props: any) => React.ReactNode;
  props?: any;
  styleButton?: SxProps<Theme>;
  anchorOrigin?: {
    vertical: "top" | "center" | "bottom";
    horizontal: "left" | "center" | "right";
  };
  transformOrigin?: {
    vertical: "top" | "center" | "bottom" | number;
    horizontal: "left" | "center" | "right" | number;
  };
  disabled?: boolean;
}

const CustomPopover: React.FC<CustomPopoverProps> = ({
  buttonLabel,
  children,
  props,
  styleButton,
  anchorOrigin = {
    vertical: "bottom",
    horizontal: "center",
  },
  transformOrigin = {
    vertical: "top",
    horizontal: "center",
  },
  disabled = false,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const handleOpen = useCallback((event: React.MouseEvent<HTMLElement>) => {
    if (props?.isOutsideCurrentMonth) return;
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const open = Boolean(anchorEl);
  const id = open ? "custom-popover" : undefined;

  return (
    <>
      <ButtonActionCalendar
        variant="outlined"
        size="small"
        onClick={handleOpen}
        sx={styleButton}
        disabled={disabled}
      >
        {buttonLabel}
      </ButtonActionCalendar>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        sx={{
          "& .MuiPaper-root": {
            borderRadius: pxToRem(8),
          },
        }}
      >
        {children({ props, onClose: handleClose })}
      </Popover>
    </>
  );
};

export default CustomPopover;
